import { restClient } from '@/Core'

import { ACTIVITY_REST_URL } from '../Contracts/Activity.types'

import type { ActivityRecord } from '../Contracts/Activity.types'

/**
 * «Завершити справу» — `POST /services/activities/{uuid}/complete {result}`
 * (`SPEC-011` §4.1, §8.5, З3). Дієслівний роут замість легасі
 * `PATCH …/status`: статус завершення бек ставить сам, фронт його не шукає.
 *
 * Відповідь — оновлена справа; `?permissions=true` просить разом із нею
 * `_permissions`, щоб кнопка «Завершити справу» зникла без окремого запиту.
 *
 * Помилки розбирає `CompleteActivityModalStore`: 422 на `result` (порожній —
 * І12), 400 «Справу вже завершено.».
 */
export const CompleteActivityTask = async (uuid: string, result: string): Promise<ActivityRecord | null> => {
    const response = (await restClient.post(
        `${ACTIVITY_REST_URL}/${encodeURIComponent(uuid)}/complete?permissions=true`,
        { json: { result } }
    )) as unknown

    return response !== null && typeof response === 'object' ? (response as ActivityRecord) : null
}
